import React from 'react';
import moment from 'moment-timezone';
import I18n from 'modules/i18n';
import Tooltip from '@/components/common/TCIReactTooltip';
import styles from '@/components/staffer/AssignmentsBasedGradesTable/Table/styles.module.scss';
import { IAssignment } from '@/components/staffer/AssignmentsBasedGradesTable/types';
import useGradesTableStore from '@/components/staffer/AssignmentsBasedGradesTable/store/useGradesTableStore';
import AssignmentOptionsMenu from './AssignmentOptionsMenu';

const AssignmentsRow = () => {
  const renderAssignmentRow = (assignment: IAssignment, lastCell) => {
    const timezone = moment.tz(moment.tz.guess()).zoneAbbr();

    const tooltipContent = (
      <div>
        <div>
          <span className="tw-font-bold">{assignment.assignment_details.type}: </span>
          <span>{assignment.assignment_details.title}</span>
        </div>
        <div>
          <span>{I18n.t('due_date')}: </span>
          <span className="tw-italic">{moment(assignment.due_datetime).format('M/DD/YY')} {timezone}</span>
        </div>
      </div>
    );

    return (
      <tr key={assignment.id} className={styles.header}>
        <td className={styles.assignmentType}>{assignment.assignment_details.type}</td>
        <th className={`${styles.assignmentDetails} ${lastCell ? styles.lastCell : ''}`}>
          <Tooltip
            html={tooltipContent}
            position="top"
            size="small"
            theme="white"
          >
            <div className="tw-flex tw-flex-row tw-items-center tw-justify-between">
              <div>
                <div className={`${styles.assignmentTitle} tw-py-0.5`}>{assignment.assignment_details.title}</div>
                <div className="tw-italic tw-font-light tw-text-very-dark-grey tw-py-0.5">
                  {I18n.t('due')} {moment(assignment.due_datetime).format('M/DD/YY')}
                </div>
                <div className="tw-py-0.5">{assignment.max_points} {I18n.t('points')}</div>
              </div>

              <AssignmentOptionsMenu assignment={assignment} />
            </div>
          </Tooltip>
        </th>
      </tr>
    );
  };

  const renderAssignments = () => {
    const assignments = useGradesTableStore(state => state.assignments);
    return assignments.map((a, i) => renderAssignmentRow(a, i === assignments.length - 1));
  };

  const spacerCell = () => (
    <tr className={`${styles.header} ${styles.spacer}`}>
      <th>
        <div className="tw-w-[12.75rem]" />
      </th>
    </tr>
  );

  return (
    <>
      {spacerCell()}
      {renderAssignments()}
    </>
  );
};

export default AssignmentsRow;
